import { MobileHistoryEmptyIconWrapperStyled, MobileHistoryEmptyStyled } from "./styled/MobileHistoryEmptyStyled";
import { useDispatch, useSelector } from "react-redux";
import { getIsUserSelectedAccountTypeLive } from "../../../app/appSelectors";
import { BinIcon } from "../../../components/icon/Icon";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { Button } from "react-bootstrap";
import { useCallback } from "react";
import { openMobileSliderPageAction } from "../../mobileAppActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../MobileSliderPages/mobileSliderPagesConstants";
import appHistory from "../../../app/appHistory";
import { MobileRouterPaths } from "../../mobileAppConstants";

function MobileHistoryEmpty() {
    const {getLangPath} = useLangContext();

    const dispatch = useDispatch();
    const isUserSelectedAccountTypeLive = useSelector(getIsUserSelectedAccountTypeLive);

    const handleClick = useCallback(() => {
        if (isUserSelectedAccountTypeLive) {
            dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.DEPOSIT));
        } else {
            appHistory.push(MobileRouterPaths.market);
        }
    }, [dispatch, isUserSelectedAccountTypeLive]);

    return <MobileHistoryEmptyStyled>
        <MobileHistoryEmptyIconWrapperStyled>
            <BinIcon name={'IcHistory'}/>
        </MobileHistoryEmptyIconWrapperStyled>
        <h4>{getLangPath('transaction_history.modal_title')}</h4>
        <p dangerouslySetInnerHTML={{__html: getLangPath('transaction_history.modal_text')}}/>
        <Button size={'lg'} variant={'primary'} onClick={handleClick}>
            {getLangPath(isUserSelectedAccountTypeLive ? 'lite_version.home.top_up' : 'transaction_history.open_position')}
        </Button>
    </MobileHistoryEmptyStyled>
}

export default MobileHistoryEmpty;
